import DreamCar from "images/dreamcar.png";

const DreamCarSection = () => {
  return (
    <div className="relative text-white py-16 px-6">
      <div className="text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Why Choose Autowurx
        </h2>
      </div>

      <div className="relative mt-10 flex flex-col md:flex-row items-center justify-center gap-10">
        <div className="space-y-6 max-w-lg">
          {/* Feature Cards */}
          {[
            {
              title: "Diverse Fleet of Vehicles",
              subtitle: "FLEET",
              description: (
                <>
                  <p>
                    At Rentalwurx, we understand that different customers have
                    different needs, which is why we proudly offer a{" "}
                    <strong>diverse fleet of vehicles</strong> to ensure we can
                    cater to every requirement. Whether you're in need of a
                    compact car for a city trip, a spacious van for family
                    travel, or a rugged 4x4 for off-road adventures, ride share,
                    we've got you covered.
                  </p>
                  <ul className="list-disc list-inside">
                    <li>
                      <strong>Variety of Vehicle Types:</strong> From
                      fuel-efficient sedans to luxury SUVs, trucks, and
                      specialty vehicles like electric cars and refrigerated
                      units, we offer a broad selection to meet all your
                      transportation needs.
                    </li>
                    <li>
                      <strong>Quality & Reliability:</strong> All vehicles are
                      well-maintained, regularly serviced, and equipped with the
                      latest features to ensure safety and comfort on every
                      journey.
                    </li>
                    <li>
                      <strong>Eco-Friendly Choices:</strong> For those looking
                      to reduce their carbon footprint, we offer electric
                      vehicles and hybrid options to make your trips more
                      sustainable.
                    </li>
                  </ul>
                  <p>
                    Choose us for a diverse fleet that fits your lifestyle, your
                    business, and your budget.
                  </p>
                </>
              ),
            },
            {
              title: "Affordable Pricing",
              subtitle: "SECURE",
              description: (
                <>
                  <p>
                    We believe that high-quality vehicle rentals shouldn’t break
                    the bank. That's why we offer affordable pricing on a wide
                    range of vehicles, ensuring you can find the perfect option
                    that fits your budget. Whether you're looking for a
                    budget-friendly sedan for a weekend getaway or a larger
                    vehicle for a long-term project, we’ve got options for every
                    financial need.
                  </p>
                </>
              ),
            },
            {
              title: "Customer Service",
              subtitle: "24/7 SUPPORT",
              description: (
                <>
                  <p>
                    At Rentalwurx, we offer 24/7 customer support to ensure
                    you're never left stranded. Whether you need assistance with
                    a booking, have questions about your rental, or run into an
                    issue on the road, our friendly team is available anytime,
                    day or night. We’re always here to make your experience
                    smooth and stress-free, no matter the hour.
                  </p>
                </>
              ),
            },
          ].map((feature, index) => (
            <div
              key={index}
              className="bg-[#000000E5] max-w-sm rounded-xl p-6 backdrop-blur-xl flex items-start gap-4"
            >
              <div>
               
                <p className="text-lg text-[#FFFFFF] font-semibold">
                  {feature.title}
                </p>
                <div className="text-sm text-[#F5F5F7B2]">
                  {feature.description}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Car Image */}
        <div className="max-w-xl">
          <img src={DreamCar} alt="Dream Car" className="" />
        </div>
      </div>
    </div>
  );
};

export default DreamCarSection;
